module.exports = __webpack_public_path__ + "static/img/shoucang.850e0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shoucang.png
// module id = 3WKG
// module chunks = 1